/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceByProductCategoryWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ResourceByProductCategoryWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ResourceByProductCategoryWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ResourceByProductCategoryWidgetConfiguration>): ResourceByProductCategoryWidgetConfiguration {
        let obj = Object.assign(new ResourceByProductCategoryWidgetConfiguration(), model);
        ResourceByProductCategoryWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceByProductCategoryWidgetConfiguration>): ResourceByProductCategoryWidgetConfiguration {
        if (!model) return null;
        return ResourceByProductCategoryWidgetConfiguration.newInstance(<ResourceByProductCategoryWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceByProductCategoryWidgetConfiguration) {
        if (!obj) return;

        models.ResourceByProductCategoryWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceByProductCategoryWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceByProductCategoryWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of Resources
     */
    resourceSelection: models.ResourceSelection;

}
